import React, { useState } from "react";
import "./DesignerAddObjectPanel.css";

const items = [
  { type: "text", label: "Add Text" },
  { type: "shape", label: "Add Shape" },
  { type: "tag", label: "Add Tag" },
  { type: "button", label: "Add Button" },
  { type: "image", label: "Add Image" },
];

const DesignerAddObjectPanel = ({ onAddObject }) => {
  const [collapsed, setCollapsed] = useState(false);

  if (collapsed) {
    return (
      <div className="daop-collapsed-wrap">
        <button
          type="button"
          className="daop-collapse-btn daop-collapse-btn--collapsed"
          onClick={() => setCollapsed(false)}
        >
          Add Object
        </button>
      </div>
    );
  }

  return (
    <div className="daop-panel">
      <div className="daop-header">
        <h3 className="daop-title">Add Object</h3>

        <button
          type="button"
          className="daop-collapse-btn"
          onClick={() => setCollapsed(true)}
          title="Collapse Add Object"
        >
          −
        </button>
      </div>

      <div className="daop-list">
        {items.map((item) => (
          <button
            key={item.type}
            type="button"
            onClick={() => onAddObject(item.type)}
            className="daop-item-btn"
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DesignerAddObjectPanel;